<template>
    <div class="row">
        <div v-if="loading" class="col-12 mt-5 mb-5" v-loading="true"></div>
        <div v-else class="col-12">
            <card>
                <form class="form-horizontal">
                    <!-- NAME -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Name *</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-input v-model="activity.name"/>
                            </div>
                        </div>
                    </div>
                    <!-- START DATE -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Start Date</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-date-picker
                                    v-model="activity.startDate"
                                    type="datetime"/>
                            </div>
                        </div>
                    </div>
                    <!-- END DATE -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">End Date</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-date-picker
                                    v-model="activity.endDate"
                                    type="datetime"/>
                            </div>
                        </div>
                    </div>
                    <!-- Speaker -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Speakers</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-select
                                    v-model="activity.speakers"
                                    multiple>
                                        <el-option
                                            v-for="speaker in $store.state.speakers"
                                            :label="speaker.name + speaker.lastName"
                                            :value="speaker._id"/>
                                </el-select>
                            </div>
                        </div>
                    </div>
                    <!-- Available Seats -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Available Seats</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-input v-model="activity.availableSeats" type="number" min="0"/>
                            </div>
                        </div>
                    </div>
                    <!-- Location -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Location</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-input v-model="activity.location"/>
                            </div>
                        </div>
                    </div>
                    <!-- Code to be displayed on Badge -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Code to be displayed on Badge</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-input v-model="activity.badgeCode"/>
                            </div>
                        </div>
                    </div>
                    <!-- Fee -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Fee</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-input v-model="activity.fee" type="number" min="0"/>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                      <label class="col-sm-2 col-form-label">Discount</label>
                      <div class="col-sm-10">
                          <div class="form-group">
                            <el-checkbox v-model="activity.is_discount">Has Discount?</el-checkbox>
                          </div>
                      </div>
                    </div>
                    <div class="discount-section">
                      <div class="row">
                        <div class="col-md-10 offset-md-2">
                          <div class="row" v-if="activity.is_discount">
                            <label class="col-sm-2 col-form-label">Discount Type</label>
                            <div class="col-sm-10">
                                <div class="form-group">
                                  <el-radio v-if="activity.is_discount" v-model="activity.discount_type" label="amount">Amount</el-radio>
                                  <el-radio v-if="activity.is_discount" v-model="activity.discount_type" label="percent">Percent</el-radio>
                                </div>
                            </div>
                          </div>
                          <div class="row" v-if="activity.is_discount">
                            <label class="col-sm-2 col-form-label">Discount Period?</label>
                            <div class="col-sm-10">
                                <div class="form-group">
                                  <el-radio v-if="activity.is_discount" v-model="activity.discount_period" :label="true">Yes</el-radio>
                                  <el-radio v-if="activity.is_discount" v-model="activity.discount_period" :label="false">No</el-radio>
                                </div>
                            </div>
                          </div>
                          <div class="discount-values" v-if="activity.is_discount && activity.discount_period">
                            <div class="discount-input-cont" v-for="(feeDiscount, feeIndex) in activity.discount_values" :key="'fee_ind_' + feeIndex">
                              <div class="row">
                                <label class="col-sm-2 col-form-label">Start Date</label>
                                <div class="col-sm-10">
                                  <div class="form-group">
                                    <el-date-picker v-model="feeDiscount.start_date" type="datetime"/>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <label class="col-sm-2 col-form-label">End Date</label>
                                <div class="col-sm-10">
                                  <div class="form-group">
                                    <el-date-picker v-model="feeDiscount.end_date" type="datetime"/>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <label class="col-sm-2 col-form-label">Discount Value</label>
                                <div class="col-sm-10">
                                  <div class="form-group">
                                    <el-input v-model="feeDiscount.value" type="number" :min="0"/>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="discount-values" v-if="activity.is_discount && !activity.discount_period">
                            <div class="discount-input-cont" v-for="(feeDiscount, feeIndex) in activity.discount_values">
                              <div class="row" v-if="feeIndex == 0">
                                <label class="col-sm-2 col-form-label">Discount Value</label>
                                <div class="col-sm-10">
                                  <div class="form-group">
                                    <el-input v-model="feeDiscount.value" type="number" :min="0"/>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" v-if="activity.is_discount && activity.discount_period">
                            <label class="col-sm-2 col-form-label" />
                            <div class="col-sm-10">
                              <el-button
                                  type="primary"
                                  class="btn btn-primary"
                                  @click="addFeesDiscountPeriod">
                                      Add Period
                              </el-button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Type Based Fee -->
                    <div
                        v-for="t in $store.state.types"
                        :key="`type-based-fee-${t._id}`">
                        <section class="fees-section">
                          <div class="row">
                            <label class="col-sm-2 col-form-label">{{ t.name }} Fee</label>
                            <div class="col-sm-10">
                                <div class="form-group">
                                    <el-input v-model="activity.typeBasedFee[t._id]" type="number" min="0"/>
                                </div>
                            </div>
                          </div>
                          <div class="row">
                            <label class="col-sm-2 col-form-label">Discount</label>
                            <div class="col-sm-10">
                                <div class="form-group">
                                  <el-checkbox v-model="activity.typeBasedDiscount.is_discount[t._id]">Has Discount?</el-checkbox>
                                </div>
                            </div>
                          </div>
                          <div class="discount-section">
                            <div class="row">
                              <div class="col-md-10 offset-md-2">
                                <div class="row" v-if="activity.typeBasedDiscount.is_discount[t._id]">
                                  <label class="col-sm-2 col-form-label">Discount Type</label>
                                  <div class="col-sm-10">
                                      <div class="form-group">
                                        <el-radio v-if="activity.typeBasedDiscount.is_discount[t._id]" v-model="activity.typeBasedDiscount.type[t._id]" label="amount">Amount</el-radio>
                                        <el-radio v-if="activity.typeBasedDiscount.is_discount[t._id]" v-model="activity.typeBasedDiscount.type[t._id]" label="percent">Percent</el-radio>
                                      </div>
                                  </div>
                                </div>
                                <div class="row" v-if="activity.typeBasedDiscount.is_discount[t._id]">
                                  <label class="col-sm-2 col-form-label">Discount Period?</label>
                                  <div class="col-sm-10">
                                      <div class="form-group">
                                        <el-radio v-if="activity.typeBasedDiscount.is_discount[t._id]" v-model="activity.typeBasedDiscount.is_period[t._id]" :label="true">Yes</el-radio>
                                        <el-radio v-if="activity.typeBasedDiscount.is_discount[t._id]" v-model="activity.typeBasedDiscount.is_period[t._id]" :label="false">No</el-radio>
                                      </div>
                                  </div>
                                </div>
                                <div class="discount-values" v-if="activity.typeBasedDiscount.is_discount[t._id] && activity.typeBasedDiscount.is_period[t._id]">
                                  <div class="discount-input-cont" v-for="(discount, pIndex) in activity.typeBasedDiscount.values[t._id]">
                                    <div class="row">
                                      <label class="col-sm-2 col-form-label">Start Date</label>
                                      <div class="col-sm-10">
                                        <div class="form-group">
                                          <el-date-picker v-model="discount.start_date" type="datetime"/>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <label class="col-sm-2 col-form-label">End Date</label>
                                      <div class="col-sm-10">
                                        <div class="form-group">
                                          <el-date-picker v-model="discount.end_date" type="datetime"/>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <label class="col-sm-2 col-form-label">Discount Value</label>
                                      <div class="col-sm-10">
                                        <div class="form-group">
                                          <el-input v-model="discount.value" type="number" :min="0"/>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="discount-values" v-else-if="activity.typeBasedDiscount.is_discount[t._id] && !activity.typeBasedDiscount.is_period[t._id]">
                                  <div class="discount-input-cont" v-for="(discount, pIndex) in activity.typeBasedDiscount.values[t._id]">
                                    <div class="row" v-if="pIndex == 0">
                                      <label class="col-sm-2 col-form-label">Discount Value</label>
                                      <div class="col-sm-10">
                                        <div class="form-group">
                                          <el-input v-model="discount.value" type="number" :min="0"/>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="row" v-if="activity.typeBasedDiscount.is_discount[t._id] && activity.typeBasedDiscount.is_period[t._id]">
                                  <label class="col-sm-2 col-form-label" />
                                  <div class="col-sm-10">
                                    <el-button
                                        type="primary"
                                        class="btn btn-primary"
                                        @click="addDiscountPeriod(t._id)">
                                            Add Period
                                    </el-button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </section>
                    </div>
                    <!-- Description -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Description</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <quill-editor v-model="activity.description"/>
                            </div>
                        </div>
                    </div>
                    <!-- Allow Multiple Checkins -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Allow Multiple Checkins</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-checkbox v-model="activity.allowMultipleCheckins" class="mt-2"/>
                            </div>
                        </div>
                    </div>
                    <!-- Provide Checkout Option -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Provide Checkout Option</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-checkbox v-model="activity.provideCheckoutOption" class="mt-2"/>
                            </div>
                        </div>
                    </div>
                    <!-- Auto Enroll -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Auto Enroll Participants from the Following Registration Types</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-checkbox-group v-model="activity.autoEnrollTypes">
                                        <el-checkbox
                                            v-for="t in $store.state.types"
                                            :key="`types-${t._id}`"
                                            :label="t._id"
                                            class="d-flex align-items-center">
                                                {{ t.name }}
                                        </el-checkbox><br/>
                                </el-checkbox-group>
                            </div>
                        </div>
                    </div>
                    <!-- Dependance Type -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Dependance Type</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-select v-model="activity.dependanceType">
                                    <el-option label="And" value="and"/>
                                    <el-option label="Or" value="or"/>
                                </el-select>
                            </div>
                        </div>
                    </div>
                    <!-- Depends on Fields -->
                    <div
                        v-for="(dependance, index) in activity.dependsOnFields"
                        :key="`dependance-${index}`"
                        class="row">
                            <label class="col-sm-2 col-form-label">Depends on Field <span v-if="index">{{ index + 1 }}</span></label>
                            <div class="col-sm-10">
                                <div class="form-group">
                                    <el-select v-model="activity.dependsOnFields[index]">
                                        <el-option
                                            v-for="(field, index) in fields"
                                            v-if="['radio', 'checkboxes', 'list'].includes(field.type)"
                                            :key="`field-${field._id}`"
                                            :value="index"
                                            :label="field.title"/>
                                        <el-option :value="null" label="None"></el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div v-if="dependance !== null" class="col-12">
                                <div class="row">
                                    <label class="col-sm-2 col-form-label">Depends on Value <span v-if="index">{{ index + 1 }}</span></label>
                                    <div class="col-sm-10">
                                        <div class="form-group">
                                            <el-select v-model="activity.dependsOnValues[index]">
                                                <el-option
                                                    v-for="(value, index) in fields[dependance].values.split('\n')"
                                                    :key="`field-value-${value}`"
                                                    :value="value"
                                                    :label="fields[dependance].labels.split('\n')[index]"/>
                                                <el-option :value="null" label="None"></el-option>
                                            </el-select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-sm-2 col-form-label"></div>
                                    <div class="col-sm-10 d-flex justify-content-end">
                                        <el-button
                                            @click="removeDependency(index)"
                                            type="text"
                                            style="color: red"
                                            class="pt-0">
                                                Remove
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                    </div>
                    <div class="row">
                        <label class="col-sm-2 col-form-label"></label>
                        <div class="col-sm-10">
                            <el-button @click="newDependance()">New Dependance</el-button>
                        </div>
                    </div>
                </form>
                <template slot="footer">
                    <div class="d-flex justify-content-end">
                        <el-button
                            @click="submit()"
                            :loading="saving"
                            type="primary"
                            class="btn btn-primary">
                                Save
                        </el-button>
                    </div>
                </template>
            </card>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    data () {
        return {
            activity: {
                eventId: this.$route.params.eventId,
                name: '',
                startDate: null,
                endDate: null,
                availableSeats: 0,
                location: '',
                badgeCode: '',
                description: '',
                speakers: [],
                allowMultipleCheckins: false,
                provideCheckoutOption: false,
                autoEnrollTypes: [],
                fee: 0,
                is_discount: false,
                discount_type: 'amount',
                discount_period: false,
                discount_values: [
                  {
                    start_date: null,
                    end_date: null,
                    value: null
                  }
                ],
                dependsOnField: null,
                dependsOnValue: null,
                typeBasedFee: {},
                typeBasedDiscount: {},
                dependsOnFields: [],
                dependsOnValues: []
            },
            content: '',
            saving: false,
            loading: true
        }
    },
    computed: {
        ...mapState([
            'fields'
        ]),
        types: function() {
          return this.$store.state.types
        }
    },
    mounted () {
        this.getData()
    },
    watch: {
      types: {
        deep: true,
        handler: function() {
          if(this.$route.name == "activities-create") {
            this.initFrom()
          }
        }
      },
      activity: {
        deep: true,
        handler: function() {
          //console.log("this.activity: ", JSON.parse(JSON.stringify(this.activity)))
        }
      }
    },
    methods: {
        submit: async function () {
            this.saving = true
            try {
              // let _formData = await Object.assign({}, this.activity);
              //   _formData.activ
                Object.keys(this.activity.typeBasedFee).forEach(k =>{
                  if(!this.activity.typeBasedFee[k]) {
                    this.activity.typeBasedFee[k] = 0
                  }
                })
                const data = {
                    ...this.activity,
                    dependsOnFields: this.activity.dependsOnFields.map(fieldIndex => this.fields[fieldIndex])
                }
                if (this.$route.params.activityId) {
                    await this.$store.dispatch('update', {
                        path: 'activities',
                        id: this.$route.params.activityId,
                        data
                    })

                    this.$notify('Information successfully updated!')
                } else {
                    await this.$store.dispatch('create', {
                        path: 'activities',
                        data
                    })
                    this.$notify('Activity was successfully created!')
                    this.$router.push({ name: 'activities' })
                }
            } catch (e) {
                console.log(e)
                console.log('error creating new activity')
            }
            this.saving = false
        },
        getData: async function () {
            this.loading = true

            try {
                let params = { filters: { eventId: this.$route.params.eventId } }
                await Promise.all([
                    this.$store.dispatch('getAll', { path: 'speakers', params }), // get speakers
                    this.$store.dispatch('getAll', { path: 'types', params }),
                    this.$store.dispatch('getAll', { path: 'fields', params })
                ])

                if (this.$route.params.activityId) {
                    const response = await this.$store.dispatch('get', { path: 'activities', key: 'activity', id: this.$route.params.activityId })
                    let activity = response.data.activity
                    let discount = response.data.discount
                    activity.dependsOnFields = activity.dependsOnFields.map(field => this.fields.findIndex(f => f._id === field)).filter(index => index !== -1)
                    if (!activity.typeBasedFee) activity.typeBasedFee = {}
                    // For type based discount
                    if(!activity.typeBasedDiscount && Object.keys(activity.typeBasedFee).length > 0) {
                      activity.typeBasedDiscount = {
                        is_discount: {},
                        type: {},
                        is_period: {},
                        values: {}
                      }
                      await this.$store.state.types.forEach(async (_item, _index) => {
                        if(discount.filter(x=>x.type != undefined && x.type == _item._id).length > 0) {
                          let _singObj = await discount.find(x=>x.type != undefined && x.type == _item._id)
                          activity.typeBasedDiscount.is_discount[_item._id] = true
                          activity.typeBasedDiscount.type[_item._id] = _singObj.discountType
                          activity.typeBasedDiscount.is_period[_item._id] = _singObj.discountPeriod
                          // Calculating Values
                          let _allObj = await [... discount.filter(x=>x.type != undefined && x.type == _item._id)]
                          let _values = [];
                          for(let _item of _allObj){
                            _values.push({
                              start_date: _item.discountStartDate,
                              end_date: _item.discountEndDate,
                              value: _item.discountValue
                            })
                          }
                          activity.typeBasedDiscount.values[_item._id] = _values
                        } else {
                          activity.typeBasedDiscount.is_discount[_item._id] = false
                          activity.typeBasedDiscount.type[_item._id] = 'amount'
                          activity.typeBasedDiscount.is_period[_item._id] = false
                          activity.typeBasedDiscount.values[_item._id] = [{
                            start_date: null,
                            end_date: null,
                            value: null
                          }]
                        }
                      });
                    }

                    // For activity main fee discount
                    if(discount.filter(x=>x.type == undefined).length > 0) {
                      let _singObj = await discount.find(x=>x.type == undefined)
                      activity.is_discount = true
                      activity.discount_type = _singObj.discountType
                      activity.discount_period = _singObj.discountPeriod
                      // Calculating Values
                      let _allObj = await [... discount.filter(x=>x.type == undefined)]
                      let _values = [];
                      for(let _item of _allObj){
                        _values.push({
                          start_date: _item.discountStartDate,
                          end_date: _item.discountEndDate,
                          value: _item.discountValue
                        })
                      }
                      activity.discount_values = _values
                    }
                    if(activity.is_discount == undefined) {
                      activity.is_discount = false
                    }
                    if(activity.discount_type == undefined) {
                      activity.discount_type = 'amount'
                    }
                    if(activity.discount_period == undefined) {
                      activity.discount_period = false
                    }
                    if(activity.discount_values == undefined) {
                      activity.discount_values = [
                        {
                          start_date: null,
                          end_date: null,
                          value: null
                        }
                      ]
                    }

                    this.activity = activity
                }
            } catch (e) {
                console.log('error getting activity')
            }

            this.loading = false
        },
        newDependance: function () {
            if (!this.activity.dependsOnFields.length || this.activity.dependsOnFields[this.activity.dependsOnFields.length - 1] !== null) {
                this.activity.dependsOnFields.push(0)
                this.activity.dependsOnValues.push('')
            }
        },
        removeDependency: function (i) {
            this.$set(this.activity, 'dependsOnFields', this.activity.dependsOnFields.filter((field, index) => index !== i))
            this.$set(this.activity, 'dependsOnValues', this.activity.dependsOnValues.filter((value, index) => index !== i))
        },
        initFrom: async function() {
          let _discounts = {
            is_discount: {},
            type: {},
            is_period: {},
            values: {}
          }
          await this.$store.state.types.forEach( async _item => {
            this.activity.typeBasedFee[_item._id] = 0
            _discounts.is_discount[_item._id] = false
            _discounts.type[_item._id] = 'amount'
            _discounts.is_period[_item._id] = false
            _discounts.values[_item._id] = [{
              start_date: null,
              end_date: null,
              value: null
            }]
            // console.log(_discounts)
          });
          this.activity.typeBasedDiscount = _discounts
        },
        addDiscountPeriod: function(_typeId) {
          let _newDiscountPeriod = {
            start_date: null,
            end_date: null,
            value: null
          }
          let _discountValues = this.activity.typeBasedDiscount.values[_typeId];
          _discountValues.push(_newDiscountPeriod);
        },
        addFeesDiscountPeriod: function() {
          let _newDiscountPeriod = {
            start_date: null,
            end_date: null,
            value: null
          }
          this.activity.discount_values.push(_newDiscountPeriod);
        }
    }
}
</script>
